import BaseDataObject from './BaseDataObject';
import JockeyTrainerStart from './JockeyTrainerStart';

export default class JockeyAbstraction extends BaseDataObject {
  getStarts() {
    return this.getObjects('starts', JockeyTrainerStart);
  }

  getId() {
    return this.getString('jockey');
  }
}
